import { PropTypes } from "@material-ui/core";
import { SnackbarKey } from "notistack";
import { ErrorMessage, ConstantMessage } from "../Core/index";
export enum PageMode {
    Create = "Create",
    Update = "Update",
    Delete = "Delete"
}

type ChildChangeHandler = {
    bivarianceHack(data?: unknown): void | Promise<unknown>;
}['bivarianceHack'];


export default class BaseViewModel {
    PageMode: PageMode = PageMode.Create;
    IsTableLoading: boolean = false;
    IsPageLoading: boolean = false;
    TableLoadingLabel: string = "";
    PageLoadingLabel: string = "";
    IsShowModal: boolean = false;
    IsShowModalCreate: Boolean = false;
    SubmitButtonText: string = ConstantMessage.DefaultCreateButtonText;
    SubmitButtonColor: PropTypes.Color = ConstantMessage.DefaultColorPrimary;


    //toast Mesages
    Messages: ErrorMessage[] = [];

    //ConfirmBox
    ConfirmBoxIsOpen: boolean = false;
    ConfirmBoxOkText: string = "";
    ConfirmBoxCancelText: string = "";
    ConfirmBoxOnButtonClick: (buttonClicked: string) => void = () => undefined;
    ConfirmBoxMessage: string = "";
    ConfirmBoxTitle: string = "";

    public OnToastEntered = (_e: unknown, _reason: unknown, key: SnackbarKey) => {
        this.Messages = this.Messages.filter(i => i.Message !== key);
    }

    public setFocus<T extends HTMLElement>(element: React.RefObject<T>) {
        if (element && element.current) {
            element.current.focus();
        }
    }

    OnChildChange?: ChildChangeHandler;
}
